import React, { useState } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface TechnologyFieldProps {
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  disabled?: boolean;
}

export function TechnologyField({
  options,
  loading,
  disabled = false,
}: TechnologyFieldProps) {
  const { t } = useTranslation('create-alarm-step');
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<string[]>([]);

  return (
    <Form.Item
      name="tecnologias"
      label={t('create-alarm-step:stepOne.createAlarmTechnologyField')}
      rules={[
        {
          required: true,
          message: t('create-alarm-step:stepOne.createAlarmTechnologyRequired'),
        },
      ]}
    >
      <Select
        mode="multiple"
        allowClear
        options={options}
        value={value}
        open={open}
        loading={loading}
        disabled={loading || disabled}
        onDropdownVisibleChange={visible => setOpen(visible)}
        onChange={vals => setValue(vals)}
        onSelect={val => {
          setValue([...value, val]);
          setOpen(false);
        }}
      />
    </Form.Item>
  );
}
